<template>
  <section class="detail-main">
    <div class="card-image">
      <img :src="detail.image" :alt="detail.title" />
    </div>
    <div class="detail-info">
      <p class="remaining">
        当前盲盒剩余{{ detail.remaining }}张{{ detail.cardColor }}卡牌
      </p>
      <p class="progress">
        当前参与人数：{{ detail.participantCount }}/{{ detail.minParticipants }}
      </p>
      <p class="rules">
        参与抽奖需要{{ detail.entryRad }} RAD，参与满{{ detail.minParticipants }}人开奖，中奖即获得一张{{ detail.rewardCard }}，未中奖退还{{ detail.refundRad }} RAD
      </p>
      <button
        class="join-btn"
        :class="{ disabled: joinDisabled }"
        :disabled="joinDisabled"
        @click="$emit('join')"
      >
        {{ joinLabel }}
      </button>
    </div>
  </section>
</template>

<script>
export default {
  props: {
    detail: {
      type: Object,
      required: true,
    },
    joining: {
      type: Boolean,
      default: false,
    },
    joinDisabled: {
      type: Boolean,
      default: false,
    },
    joinLabel: {
      type: String,
      default: "立即参与",
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-main {
  display: flex;
  gap: 16px;
  padding: 0 30px;
}

.card-image {
  flex: 0 0 42%;
  overflow: hidden;

  img {
    display: block;
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}

.detail-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.remaining,
.progress {
  margin: 0 0 12px;
  font-size: 28px;
  line-height: 1.4;
  color: #fff;
}

.rules {
  margin: 0 0 20px;
  font-size: 26px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.85);
}

.join-btn {
  margin-top: auto;
  width: 100%;
  height: 72px;
  border: none;
  border-radius: 36px;
  font-size: 28px;
  color: #fff;
  background: #7338ff;
  cursor: pointer;
  transition: opacity 0.2s;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:active:not(:disabled) {
    opacity: 0.8;
  }

  &.disabled,
  &:disabled {
    background: rgba(255, 255, 255, 0.2);
    color: rgba(255, 255, 255, 0.5);
    cursor: not-allowed;
  }
}
</style>
